import { render, staticRenderFns } from "./BusinessBookingOptionsView.vue?vue&type=template&id=22df20f8&scoped=true&"
import script from "./BusinessBookingOptionsView.vue?vue&type=script&lang=ts&"
export * from "./BusinessBookingOptionsView.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessBookingOptionsView.vue?vue&type=style&index=0&id=22df20f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22df20f8",
  null
  
)

export default component.exports